// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3CA9u","emails":"CreateEditClinics_emails__BktHp","emailTagLabel":"CreateEditClinics_emailTagLabel__1tKSW"};